import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BcpFormsModule } from '@bcp/ng-forms';
import { FormLoginComponent } from './form.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormLoginComponent
  ],
  exports: [
    FormLoginComponent
  ],
  imports:[
    CommonModule,
    BcpFormsModule,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FormLoginModule { }
